import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageSquare, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export const ContactButton = ({ contextType, contextId, label = "Conversar na plataforma", className = "", fullWidth = true }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const start = async () => {
    if (!user) {
      toast.info("Entre na sua conta para conversar.");
      navigate("/login");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/conversations/start", { context_type: contextType, context_id: contextId });
      navigate(`/dashboard?tab=messages&c=${data.id}`);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      data-testid={`contact-btn-${contextType}-${contextId}`}
      onClick={start}
      disabled={loading}
      className={`${fullWidth ? "w-full" : ""} inline-flex items-center justify-center gap-2 bg-[#1b5e3f] hover:bg-[#13422c] text-white rounded-xl py-3 px-4 text-sm font-medium transition-colors disabled:opacity-60 ${className}`}
    >
      {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <MessageSquare className="w-4 h-4" />} {label}
    </button>
  );
};
